import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AspAutoscoreComponent } from './asp-autoscore.component';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';

// const routes: Routes = [
//   {
//       path: 'autoscore',
//       component: AspAutoscoreComponent,
      
      
//   },
// ];

@NgModule({
  declarations: [AspAutoscoreComponent],
  imports: [
    CommonModule
  ],
      exports: [AspAutoscoreComponent,RouterModule,
        MatIconModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
        MatProgressBarModule,
        MatInputModule,
        MatFormFieldModule,
        BrowserAnimationsModule,
        ReactiveFormsModule

      ],
  
})
export class AspAutoscoreModule { }
